package com.kinoshazam.analytics

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

@OptIn(ExperimentalEncodingApi::class)
fun userIdFromJwt(accessToken: String): String? {
    val payload = accessToken.split('.').getOrNull(1) ?: return null
    val json = runCatching {
        val decoded = Base64.UrlSafe
            .withPadding(Base64.PaddingOption.ABSENT_OPTIONAL)
            .decode(payload)
            .decodeToString()
        Json.parseToJsonElement(decoded).jsonObject
    }.getOrNull() ?: return null
    return json["userId"]?.jsonPrimitive?.contentOrNull
}
